var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1312318089"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624646",
    width: 24,
    height: 24,
    rx: 6,
    fill: "#5D63C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE6\xB7\xBB\xE5\x8A\xA012",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7509 8.99957C12.7509 8.58536 12.4151 8.24957 12.0009 8.24957C11.5867 8.24957 11.2509 8.58536 11.2509 8.99957V11.2507H9.00024C8.58603 11.2507 8.25024 11.5865 8.25024 12.0007C8.25024 12.4149 8.58603 12.7507 9.00024 12.7507H11.2509V15.001C11.2509 15.4153 11.5867 15.751 12.0009 15.751C12.4151 15.751 12.7509 15.4153 12.7509 15.001V12.7507H15.0017C15.4159 12.7507 15.7517 12.4149 15.7517 12.0007C15.7517 11.5865 15.4159 11.2507 15.0017 11.2507H12.7509V8.99957Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8c69d51bbd3550ed43e506fb86604897.svg";
export { ForwardRef as ReactComponent };